import type { ReactNode } from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * Hinweisbanner für sensible Dimensionen (Art. 9 DSGVO / § 35 SGB I).
 * Signalisiert Datensparsamkeit + Verschlüsselung, behördentauglich, ruhig.
 */
export function SensitiveNote({ children }: { readonly children: ReactNode }) {
  return (
    <aside
      role="note"
      className="flex items-start gap-3 rounded-sm border-l-4 border-stone-900 bg-stone-50 px-4 py-3"
    >
      <ShieldCheck size={18} className="mt-0.5 flex-shrink-0 text-stone-700" aria-hidden="true" />
      <p className="font-serif text-sm text-stone-700">{children}</p>
    </aside>
  );
}
